<template>
  <v-dialog
    :model-value="modelValue"
    :persistent="persistent"
    :width="width"
    :max-width="maxWidth"
    :scrollable="scrollable"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="text-h5 bg-primary text-white">
        <slot name="title">{{ title }}</slot>
        <v-btn
          color="white"
          icon
          class="to-the-right"
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <slot />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AppDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    width: {
      type: [String, Number],
      default: undefined,
    },
    maxWidth: {
      type: [String, Number],
      default: undefined,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue", "close"],
};
</script>

<style scoped>
.to-the-right {
  float: right;
}
</style>
